import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DocumentSelector from './DocumentSelector';
import CVForm from './forms/CVForm';
import CoverLetterForm from './forms/CoverLetterForm';
import PersonalStatementForm from './forms/PersonalStatementForm';
import CVEditor from './editors/CVEditor';
import CoverLetterEditor from './editors/CoverLetterEditor';
import PersonalStatementEditor from './editors/PersonalStatementEditor';
import './ApplicationBuilderPage.css';

const ApplicationBuilderPage = () => {
  return (
    <div className="application-builder-page">
      <main className="application-builder-main">
        <Routes>
          <Route path="/" element={<DocumentSelector />} />
          <Route path="/form/cv" element={<CVForm />} />
          <Route path="/form/cover_letter" element={<CoverLetterForm />} />
          <Route path="/form/personal_statement" element={<PersonalStatementForm />} />
          <Route path="/editor/cv" element={<CVEditor />} />
          <Route path="/editor/cover_letter" element={<CoverLetterEditor />} />
          <Route path="/editor/personal_statement" element={<PersonalStatementEditor />} />
        </Routes>
      </main>
    </div>
  );
};

export default ApplicationBuilderPage;
